import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

import { Button, DropDownField, TextInputField } from '../../../helpers'
import BillingAddressCards from '../../../common/BillingAddressCards'
import ShippingAddressCards from '../../../common/ShippingAddressCards'

import { raiseToast } from '../../../services/redux/reducers/toast/toast'
import { createInternalTransferInvoice } from '../../../services/api/buyerInvoice'
import { DATE_FORMAT } from '../../../constants'


const CreateInternalTransferInvoice = (props) => {
    const { buyerInvoice, pmBillAddresses, procmartStates, warehouseShipAddresses, setInternalTransferInvoice, setIsVisibleInternalTransferInv, setIsLoading } = props

	const [selectedProcState, setSelectedProcState] = useState("")
	const [selectedPMBillAddrId, setSelectedPMBillAddrId] = useState(null)
	const [selectedBillAddrId, setSelectedBillAddrId] = useState(null)
	const [selectedShipAddrId, setSelectedShipAddrId] = useState(null)

	const dispatch = useDispatch()
    const navigate = useNavigate()

	const handleProcmartState = (e) => {
        setSelectedProcState(e.target.value)
		setSelectedBillAddrId(null)
		//setSelectedShipAddrId(null)

        const selectedBillAddr = pmBillAddresses.find((eachBillAddrr) => eachBillAddrr.stateId === e.target.value)
        setSelectedPMBillAddrId(selectedBillAddr.billAddrId)
    }

	const handleCreateInternalTransfer = async () => {
        if(!window.confirm("Confirm to generate the Internal transfer invoice.")){
            return
        }

        setIsLoading(true)

        const internalTransferInvoiceRes = await createInternalTransferInvoice({buyerInvoice, billAddrId: selectedBillAddrId, shipAddrId: selectedShipAddrId, pmBillAddrId: selectedPMBillAddrId})

        if(internalTransferInvoiceRes.failure){
            setIsLoading(false)
            return dispatch(raiseToast({severity:'error', detail: internalTransferInvoiceRes.data.error, life: 3000}))
        } else {
            console.log("internalTransferInvoiceRes", internalTransferInvoiceRes)
            setIsVisibleInternalTransferInv(false)
            setInternalTransferInvoice(internalTransferInvoiceRes.data?.internalTransferInvoice)
			if(internalTransferInvoiceRes.data?.internalTransferInvoice?.buyerInvoiceId){
				window.open(`/buyerInvoice/${internalTransferInvoiceRes.data?.internalTransferInvoice?.buyerInvoiceId}`)
			}
        }
        setIsLoading(false)
	}

	let buyerPONumbers = buyerInvoice?.docNo
	let buyerPODate = moment(new Date()).format(DATE_FORMAT)

	let visibleBillAddresses = pmBillAddresses.filter(eachBillAddrs => eachBillAddrs.billAddrId !== selectedPMBillAddrId)

    return (
        <div className='flex flex-column col-12 pb-0 m-0 p-0 justify-content-between'>
            <div className='flex flex-row col-12 mb-0 mt-0 p-0'>
				<div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <DropDownField name="procmart state" value={selectedProcState} labelText="Procmart State" options={procmartStates} optionLabel="stateName" optionValue="stateId" onChange={handleProcmartState} />  
                </div>
				<div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <TextInputField name="PO Number" value={buyerPONumbers} disabled labelText="PO Number" />
                </div>
				<div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <TextInputField name="PO Date" value={buyerPODate} disabled labelText="PO Date" />
                </div>
            </div>

			<div className='hr-line' style={{marginTop: "0px"}}></div>

			<p className='font-semibold text-xs mb-2 mt-3'>Billing address<span style={{ color: 'red', marginLeft: '1px' }}>*</span></p>
			<BillingAddressCards billingAddresses={visibleBillAddresses} selectedAddressId={selectedBillAddrId} handleBillingAddress={setSelectedBillAddrId} />

			<p className="font-semibold text-xs mb-2 mt-1">Shipping Address<span style={{ color: 'red', marginLeft: '1px' }}>*</span></p>
			<ShippingAddressCards shippingAddresses={warehouseShipAddresses} selectedAddressId={selectedShipAddrId} handleShippingAddress={setSelectedShipAddrId} showAddShipAddr={false} />

			<div className="flex flex-row justify-content-end">
				<Button label="CREATE INTERNAL TRANSFER" onClick={handleCreateInternalTransfer} />
			</div>
        </div>
    )
}

export default CreateInternalTransferInvoice